var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in","hide-sign-up":true,"username-alias":"email"},slot:"sign-in"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }